import { useCallback, useRef, useState } from 'react';
import { To, useNavigate } from 'react-router-dom';

interface UseDiscardFormDialogProps {
  navigateTo: To;
}

interface UseDiscardFormDialogReturn {
  dialogRef: React.Ref<HTMLVdsDialogElement>;
  setIsFormDirty: React.Dispatch<React.SetStateAction<boolean>>;
  leaveView: () => void;
  onCancel: () => void;
  onDiscard: () => void;
}

export const useDiscardFormDialog = ({
  navigateTo,
}: UseDiscardFormDialogProps): UseDiscardFormDialogReturn => {
  const navigate = useNavigate();

  const dialogRef = useRef<HTMLVdsDialogElement>(null);

  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);

  const leaveView = useCallback(() => {
    navigate(navigateTo);
  }, [navigate, navigateTo]);

  const onCancel = useCallback(() => {
    if (isFormDirty) {
      dialogRef?.current?.open();
    } else {
      leaveView();
    }
  }, [leaveView, isFormDirty]);

  const onDiscard = useCallback(() => {
    dialogRef?.current?.close();
    leaveView();
  }, [leaveView]);

  return {
    dialogRef,
    setIsFormDirty,
    leaveView,
    onCancel,
    onDiscard,
  };
};
